import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import QuoteModal from '@/components/PowerOcean/Home/QuoteModal';

export default function E({ langKey }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');
    const [showQuoteModal, setShowQuoteModal] = useState(false);

    const handleLearMore = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'solution_button',
                list_name: t('secE_title'),
                button_name: t('secA_btn'),
            });
        } catch (e) {
            console.error(e);
        } finally {
            if (langKey === 'solarspeicher') {
                const target = document.querySelector('.power-ocean-collection-N') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target?.offsetTop,
                        behavior: 'smooth',
                    });
                }
                return;
            }
            setShowQuoteModal(true);
        }
    };

    return (
        <div className={`power-ocean-collection-E ${css['power-ocean-collection-E']}`}>
            <div className="text-box">
                <p className="title">{t('secE_title')}</p>
                <p className="desc">{t('secE_desc')}</p>
            </div>
            <div className="img">
                <NextImage src={require('@publicLocal/power-ocean/collection/pc/de/5.jpg')} alt={t('secE_title')} aria-label={t('secE_title')} />
            </div>
            {langKey !== 'solarspeicher' && (
                <p className="pop-btn" onClick={handleLearMore}>
                    {t('secA_btn')}
                </p>
            )}
            {showQuoteModal && <QuoteModal callback={() => setShowQuoteModal(false)} initType={0} />}
        </div>
    );
}
